import { LayoutEnum } from '@goldcast/api/content';
import { LayoutChange } from '../types/RemotionPlayerConfigTypes/Segment/LayoutChange';
import { BaseConfig } from '../types/speaker-types';
import { getLayoutConfig } from './getLayoutConfig';

export const isLayoutAudiogram = (layout: LayoutEnum) => {
  return layout === 'AUDIOGRAM';
};

export const isLayoutDefault = (layout: LayoutEnum) => {
  return layout === 'DEFAULT';
};

export const isLayoutGrid = (layout: LayoutEnum) => {
  return layout === 'GRID';
};

export const isLayoutPip = (layout: LayoutEnum) => {
  return layout === 'PIP';
};

export const isLayoutActiveSpeaker = (layout: LayoutEnum) => {
  return layout === 'SPEAKER';
};

export const isLayoutFocus = (layout: LayoutEnum) => {
  return layout === 'FOCUS';
};

export const isSpeakerLayout = (layout: LayoutEnum) => {
  return !isLayoutAudiogram(layout) && !isLayoutDefault(layout);
};

export const getFinalConfigForLayout = (layout: LayoutChange | undefined, videosToShow: string[]): BaseConfig[] => {
  if (!layout) {
    return [];
  }
  if (isLayoutAudiogram(layout.layout)) {
    return [];
  }
  // Per-clip useNewLayoutEngine wins over the global flag so migrated clips stay on the
  // runtime engine even during a flag rollback (fixes the dead-mirror bug on the render path:
  // getFinalConfigForLayout previously never forwarded isNewLayoutsEnabled to getLayoutConfig,
  // so speaker_direction mirroring was effectively dead on the full render path).
  const config = getLayoutConfig({
    size: layout.size,
    layout: layout.layout,
    fitMode: layout.fitMode,
    hideBorders: layout.hideBorders,
    speakerDirection: layout.speakerDirection,
    speakerCount: videosToShow.length,
    hasScreenshare: layout.hasScreenshare,
    roundCorners: layout.roundCorners,
    pipShape: layout.pipShape,
    pipPosition: layout.pipPosition,
    isNewLayoutsEnabled: layout.useNewLayoutEngine
  });
  if (!config) {
    return [
      {
        style: { display: 'none' },
        containerStyle: { display: 'none' }
      }
    ];
  }
  return config;
};
